export default __webpack_public_path__ + "static/media/january.1c66d8c9.png";